import { render } from "./InfoOverlay.vue?vue&type=template&id=3fbc9252&scoped=true"
import script from "./InfoOverlay.vue?vue&type=script&lang=js"
export * from "./InfoOverlay.vue?vue&type=script&lang=js"

import "./InfoOverlay.vue?vue&type=style&index=0&id=3fbc9252&scoped=true&lang=css"

import exportComponent from "/home/cherry/safer_pet/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbc9252"]])

export default __exports__